<template>
<div class="today_bp">
  <div class="today_bp_title">
    

    <b>今日必拼</b>
    <div v-if="todaymp.length>1" @click="gotoPtList" v-stat="statMore">更多<img class='pt_more' src="@/assets/images/arrow.png" /></div>
  </div>
  <div class="today_bp_wrap" v-if="todaymp.length<3">
    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in todaymp" :key="item.itemId" @click="gotoDetail(item)">
          <div class="today_bp_con">
            <div class="today_bp_item" >
              <div class="today_bp_itemL">
                <van-image :src="item.mainImage+'?x-oss-process=style/750w-2'" width="2.8rem" height="2.8rem" lazy-load>
                  <template v-slot:loading>
                    <div class="loadingbg"></div>
                  </template>
                  <template v-slot:error>
                    <div class="loadingbg"></div>
                  </template>
                </van-image>
              </div>
              <div class="today_bp_itemR">
                <h4 class="today_bp_item_tit"><img class='pt_icon' src="@/assets/images/pt_icon.png" />{{item.itemName}}</h4>
                <p class="today_bp_item_des">{{item.sellPoint }}</p>
                <div class="goods_price">
                  <gprice :price="item.pintuanPrice" color="#FA4949" fsize="12px" isize="18px"></gprice>
                  <span class="xiangscore"><img src="@/assets/images/score_dikou.png" /></span>
                </div>
                <p class="today_bped" v-if="item.attendanceCount">已拼{{item.attendanceCount}}人</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar" slot="scrollbar"></div>
    </div>
  </div>
  <div class="today_bp_wrap_more" v-if="todaymp.length>2">
    <div v-swiper:mySwiper2="swiperOption2">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in todaymp" :key="item.itemId"  v-stat="{event:'event_click',data:{ed:{idx:item.itemId},md:'拼团'}}" @click="gotoDetail(item)">
          <div class="today_bp_con">
            <div class="today_bp_item_more">
              <div class="today_bp_item_more_img">
                <van-image :src="item.mainImage+'?x-oss-process=style/750w-2'" width="2.8rem" height="2.8rem" lazy-load>
                  <template v-slot:loading>
                    <div class="loadingbg"></div>
                  </template>
                  <template v-slot:error>
                    <div class="loadingbg"></div>
                  </template>
                </van-image>
              </div>
              <div class="goods_price">
                <gprice :price="item.pintuanPrice" color="#FA4949" fsize="12px" isize="18px"></gprice>
              </div>
              <p class="today_bped" v-if="item.attendanceCount">已拼{{item.attendanceCount}}人</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar" slot="scrollbar"></div>
    </div>
  </div>
</div>
</template>
<script>
import gprice from '../../components/gprice'
export default {
  name: '',
  components:{
    gprice
  },
  props:{
    todaymp:{
      type: Array,
      default: function(){
        return []
      }
    }
  },
  data () {
    return {
      title: '',
      statMore:{
        event: "evn_group_clickmore",
        data:{
          ed:{},
          curl: "/"
        }
      },
      swiperOption: {
        
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true
        }
      },
      swiperOption2: {
        slidesPerView: 3,
        
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true
        }
      }
    }
  },
  mounted(){
    // this.mySwiper.slideTo(3, 1000, false)
  },
  methods: {
    gotoDetail(item) {
      let params = {
        saleSkuId: item.itemId
      }
      this.$navigateTo("detail",params)
      // this.$service.getStatisCommon("env_close_page",{});
    },
    gotoPtList(){
      let params = {
        saleCategoryId: '7025',
        urlstr:"collageList"
      }
      this.$navigateTo("collageList",params)
      this.$service.getStatisCommon("env_close_page",{});
    }
  }
}
</script>
<style scoped lang='less'>
/**
首页今日必拼
*/
.swiper-container-horizontal > .swiper-scrollbar{
  height:2px;
}
.swiper-container{
  padding-bottom: 8px;
}
.swiper-scrollbar .swiper-scrollbar-drag{
  background: rgba(0, 0, 0, 0.2);
}
.today_bp{
  width:9.4667rem;
  background:rgba(255,255,255,1);
  border-radius:0.2133rem;
  padding: 0 0.2667rem 0.1333rem;
  box-sizing: border-box;
  margin-top: 0.2667rem;
}
.today_bp_title{
  display: flex;
  height: 1.12rem;
  justify-content: space-between;
  align-items: center;
}
.today_bp_title b{
  font-size:0.4267rem;
  font-family:AlibabaPuHuiTiM;
  color:rgba(0,0,0,0.86);
}
.today_bp_title div{
  display: flex;
  height: 1.12rem;
  align-items: center;
  font-size:0.3733rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.68);
}
.pt_more {
  width:0.4267rem;
  height: 0.4267rem;
}
.today_bp_wrap{
  width: 8.9333rem;
  height: 3.0667rem;
}
.today_bp_wrap_more{
  width: 8.9333rem;
  // height: 4.2667rem;
}
.today_bp_con{
  display: flex;
  flex-direction: row;
}
.today_bp_item{
  width: 8.9333rem;
  display: flex;
}
.today_bp_item_more{
  width: 2.8rem;
  margin-right: 0.2667rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.today_bp_item_more_img{
  margin-bottom: 0.2133rem;
}
.today_bp_itemL{
  margin-right: 0.1333rem;
}
.today_bp_itemR{
  padding-right: 0.1333rem;
}
.today_bp_item_tit{
  font-size:0.3467rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  line-height: 1.4;
  word-break: break-all;
  color: rgba(0, 0, 0, 0.86);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.today_bp_item_des{
  line-height: 1.4;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  font-size: 0.2933rem;
  color: rgba(0, 0, 0, 0.4);
  margin: 0.1333rem 0 0.3733rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.xiangscore img{
  width: 1.5733rem;
  height: 0.3733rem;
}
.today_bped{
  height:0.3733rem;
  font-size:0.2667rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.4);
  line-height:0.3733rem;
}
.loadingbg{
  width: 2.8rem;
  height: 2.8rem;
  background: url('../../assets/images/default_bg2x.png') no-repeat;
  background-size: 100% 100%;
}
</style>